import { render, staticRenderFns } from "./asignar_asignaturas_a_docentes.vue?vue&type=template&id=41549638&scoped=true"
import script from "./asignar_asignaturas_a_docentes.vue?vue&type=script&lang=js"
export * from "./asignar_asignaturas_a_docentes.vue?vue&type=script&lang=js"
import style0 from "./asignar_asignaturas_a_docentes.vue?vue&type=style&index=0&id=41549638&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41549638",
  null
  
)

export default component.exports